import { Children, type ReactNode } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { headingId } from "../markdownOutline";

function nodeText(node: ReactNode): string {
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (!node) return "";
  if (Array.isArray(node)) return node.map(nodeText).join("");
  if (typeof node === "object" && "props" in node) return nodeText((node as { props: { children?: ReactNode } }).props.children);
  return Children.toArray(node).map(nodeText).join("");
}

export function Markdown({ children, scope = "article" }: { children: string; scope?: string }) {
  let headingIndex = 0;
  const heading = (level: 1 | 2 | 3) => function Heading({ children: headingChildren }: { children?: ReactNode }) {
    const id = headingId(scope, headingIndex++, nodeText(headingChildren));
    const Tag = `h${level}` as "h1" | "h2" | "h3";
    return <Tag id={id} className="markdown-heading">{headingChildren}</Tag>;
  };
  return <div className="markdown-body"><ReactMarkdown remarkPlugins={[remarkGfm]} components={{ h1: heading(1), h2: heading(2), h3: heading(3) }}>{children}</ReactMarkdown></div>;
}
